import { apiTicketProvider } from "./apiTicketProvider";
import { mockTicketProvider } from "./mockTicketProvider";
import { isMockEnabled } from "../../../config/featureConfig";

export const ticketProvider = isMockEnabled("ticket")
  ? mockTicketProvider
  : apiTicketProvider;

